import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param actionids
 * @param route
 */
function hasPermission(actionids, route) {
  if (route.meta && route.meta.actionid) {
    return actionids.includes(route.meta.actionid)
  } else {
    return false
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param actionids
 */
export function filterAsyncRoutes(routes, actionids) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(actionids, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, actionids)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, actionids) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, actionids) || []
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js